export default function isMonthValueValid(value: string) {
	if (value === '') return false;
	const valueAsNumber = parseInt(value);
	if (valueAsNumber <= 0) return false;
	if (valueAsNumber > 12) return false;
	if (valueAsNumber < 10) return value.includes('0');
	return true;
}
